import { useState } from 'react';
import { RadioGroup } from '@headlessui/react';
import { CheckCircleIcon } from '@heroicons/react/20/solid';

type RadioCardsProps = {
    cards: { value: string; title: string; description: string }[];
    value: string;
    onChange: (value: string) => void;
};

export default function RadioCards({ cards, value, onChange }: RadioCardsProps): JSX.Element {
    return (
        <RadioGroup value={value} onChange={onChange}>
            <div className="flex gap-4">
                {cards.map((card) => (
                    <RadioGroup.Option
                        key={card.title}
                        value={card.value}
                        className={({ checked, active }): string => {
                            return `${checked ? 'border-transparent' : 'border-gray-300'} ${
                                active ? 'border-indigo-500 ring-2 ring-indigo-500' : ''
                            } relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none w-full`;
                        }}
                    >
                        {({ checked, active }): JSX.Element => (
                            <>
                                <span className="flex flex-1">
                                    <span className="flex flex-col">
                                        <RadioGroup.Label as="span" className="block text-sm font-medium text-gray-900">
                                            {card.title}
                                        </RadioGroup.Label>
                                        <RadioGroup.Description as="span" className="mt-1 flex items-center text-sm text-gray-500">
                                            {card.description}
                                        </RadioGroup.Description>
                                    </span>
                                </span>
                                <CheckCircleIcon className={`${!checked ? 'invisible' : ''} h-5 w-5 text-indigo-600`} aria-hidden="true" />
                                <span
                                    className={`${active ? 'border' : 'border-2'} ${
                                        checked ? 'border-indigo-500' : 'border-transparent'
                                    }  pointer-events-none absolute -inset-px rounded-lg`}
                                    aria-hidden="true"
                                />
                            </>
                        )}
                    </RadioGroup.Option>
                ))}
            </div>
        </RadioGroup>
    );
}
